import themeUtils from '../themeUtils';

export default class DynamicVideoWithTextOverlay {
  constructor(section) {
    this.el = section.el;
    this.colorOverlay = this.el.querySelector('[data-video-overlay-color]');
    this.textContentOverlay = this.el.querySelector('[data-video-overlay-text-content]');
    this.video = this.el.querySelector('iframe');
    this.videoWrapper = this.el.querySelector('[data-video-wrapper]');
    if (!this.video) return;

    this.videoWrapper.addEventListener('click', () => this._playVideo());
    this.textContentOverlay.addEventListener('click', () => this._playVideo());
  }

  _prepareVideo() {
    // Get src of video, and replace with auto-play url
    const videoSrc = this.video.getAttribute('src');
    const delimiter = (videoSrc != null ? videoSrc.indexOf('?') : undefined) === -1 ? '?' : '&';
    const videoSrcNew = `${videoSrc}${delimiter}autoplay=1`;
    this.video.setAttribute('src', videoSrcNew);
  }

  _playVideo() {
    const windowWidth = themeUtils.windowWidth();

    this._prepareVideo();

    setTimeout(() => {
      if (this.colorOverlay) {
        this.colorOverlay.classList.add('overlay-inactive');
      }

      if (this.textContentOverlay && windowWidth > themeUtils.breakpoints.small) {
        this.textContentOverlay.style.display = 'none';
      }
    }, 100);
  }

  onSectionUnload() {
    this.remove();
  }

  remove() {
    this.videoWrapper.removeEventListener('click', () => this._playVideo());
    this.textContentOverlay.removeEventListener('click', () => this._playVideo());
    if (this.video) {
      this.video.remove();
    }
  }
}
